/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Watermark_Alignment_BottomInputs */



/**
* | output |
* | --- |
* | "Bottom" |
*
* @param {Options_Watermark_Alignment_BottomInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_watermark_alignment_bottom = /** @type {((inputs?: Options_Watermark_Alignment_BottomInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Watermark_Alignment_BottomInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Bas")
	if (locale === "de") return /** @type {LocalizedString} */ ("Unten")
	if (locale === "it") return /** @type {LocalizedString} */ ("In basso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Снизу")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abajo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("底部")
	if (locale === "ja") return /** @type {LocalizedString} */ ("下")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नीचे")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fundo")
	return /** @type {LocalizedString} */ ("Bottom")
});